import script from "./Overview.vue?vue&type=script&setup=true&lang=ts"
export * from "./Overview.vue?vue&type=script&setup=true&lang=ts"

import "./Overview.vue?vue&type=style&index=0&id=210f98c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210f98c4"]])

export default __exports__